export const UPDATE_VC_PAGE_VISIBILITY = 'UPDATE_VC_PAGE_VISIBILITY';

export const updateVCPageVisibility = isVisible => ({
  type: UPDATE_VC_PAGE_VISIBILITY,
  isVisible,
});
